import { useEffect } from "react";
import { useReduxStore } from "../../hooks/useReduxStore";

const useLayers = () => {
  const { getState } = useReduxStore();
  const {
    homeBanners,
    popularLoading,
    trendingLoading,
    categoriesItems,
    popularItems,
    trendingItems,
  } = getState("Home");

  useEffect(() => {
    document.body.style.overflowX = "hidden";
  }, []);

  return {
    homeBanners,
    popularLoading,
    trendingLoading,
    categoriesItems,
    popularItems,
    trendingItems,
  };
};

export default useLayers;
